import React from 'react'
import { useForm } from 'react-hook-form'
import { Button } from 'reactstrap'
import { Form } from 'react-bootstrap'
import { message } from 'antd'

import { storeNotification } from '../services'
import { handleError } from '../../../helpers'

export default function NewNotificationForm({ reload }) {
	const { handleSubmit, register, formState: { errors }, reset } = useForm()

	const onSubmit = values => {
		storeNotification(values)
			.then(() => {
				message.success('Notificación creada exitosamente')
				reset()
				reload()
			})
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<Form onSubmit={handleSubmit(onSubmit)}>
				<Form.Group>
					<Form.Label>Tipo</Form.Label>
					<Form.Control
						as="select"
						{...register('level', { required: true })}
					>
						<option value="info">Informativa (Azul)</option>
						<option value="warning">Advertencia (Amarilla)</option>
						<option value="danger">Importante (Roja)</option>
						<option value="success">Confirmación (Verde)</option>
					</Form.Control>
				</Form.Group>
				<Form.Group>
					<Form.Label>Mensaje</Form.Label>
					<Form.Control 
						as="textarea"
						{...register('body', { required: true })}
					/>
					{ errors.body && <Form.Text className="text-warning">Este campo es requerido</Form.Text> }
				</Form.Group>
				<Button type="submit" color="primary">Crear Notificación</Button>
			</Form>
		</React.Fragment>
	)
}